import { LuneThemeNew, Text, Tile } from '@lune-fe/lune-ui-lib'
import { Box, SxProps } from '@mui/material'
import { MouseEvent, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

import useActiveRoutePath from 'hooks/useActiveRoutePath'
const { palette } = LuneThemeNew

interface INavItemProps {
    href?: string
    children: ReactNode
    icon?: ReactNode
    rightIcon?: ReactNode
    target?: string
    onClickCallback?: () => void
    sx?: SxProps
    label?: string
}

const LinkTile = ({
    children,
    icon,
    rightIcon,
    href,
    target,
    onClickCallback,
    sx,
    label,
    ...rest
}: INavItemProps) => {
    const activeRoute = useActiveRoutePath()
    const navigate = useNavigate()

    const handleClick = (e: MouseEvent<HTMLElement>) => {
        e.preventDefault()
        onClickCallback?.()
        if (!href) {
            return
        }
        target ? window.open(href, target) : navigate(href)
    }

    const isActive =
        !!href && !!activeRoute && (activeRoute === href || activeRoute.startsWith(`${href}/`))

    return (
        <Tile
            selected={isActive}
            key={`key-` + href}
            href={href}
            onClick={handleClick}
            icon={icon}
            rightIcon={rightIcon}
            sx={{
                position: 'relative',
                height: '40px',
                '.MuiTypography-root': {
                    color: `${palette.TextPrimary} !important`,
                    '&.label-text': {
                        color: `${palette.White} !important`,
                    },
                },
                svg: {
                    color: `${palette.TextPrimary} !important`,
                },
                '.MuiListItemIcon-root': {
                    width: '24px',
                    height: '24px',
                    mr: 2,
                    svg: {
                        fill: `${palette.TextSecondary} !important`,
                    },
                },
                '.MuiButtonBase-root': {
                    borderRadius: '8px !important',
                    padding: '0 8px 0 12px',
                },
                '.MuiListItemButton-root ': {
                    background: isActive ? palette.Surface400 : palette.Surface100,
                    '&:hover': {
                        background: palette.Surface300,
                    },
                },
                '> .MuiBox-root': {
                    background: isActive ? palette.Surface400 : palette.Surface100,
                    '&:hover': {
                        background: palette.Surface300,
                    },
                },
                ...sx,
            }}
            {...rest}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                }}
            >
                <Text variant={'body3'}>{children}</Text>
                {label && (
                    <Text
                        className={'label-text'}
                        variant={'caption'}
                        sx={{
                            backgroundColor: `black`,
                            color: `white !important`,
                            borderRadius: '20px',
                            height: '20px',
                            lineHeight: '20px',
                            fontWeight: '700',
                            pl: 1,
                            pr: 1,
                            mr: 1,
                        }}
                    >
                        {label}
                    </Text>
                )}
            </Box>
        </Tile>
    )
}

export default LinkTile
